import { cn } from "../lib/utils";

interface ClassEntry {
  time: string;
  label: string;
  duration: string;
}

const schedule: Record<string, ClassEntry[]> = {
  Mon: [
    { time: "8:30AM", label: "10P Jiu Jitsu", duration: "8:30–10:00AM" },
    { time: "12:00PM", label: "Muay Thai", duration: "12:00–1:00PM" },
    { time: "12:00PM", label: "Open Mat", duration: "12:00–1:00PM" },
    { time: "6:00PM", label: "10P Jiu Jitsu", duration: "6:00–7:00PM" },
    { time: "6:00PM", label: "Muay Thai", duration: "6:00–7:00PM" },
    { time: "7:00PM", label: "Comp Class", duration: "7:00–8:00PM" },
    { time: "8:00PM", label: "MMA", duration: "8:00–9:00PM" },
  ],
  Tue: [
    { time: "5:00AM", label: "10P Jiu Jitsu", duration: "5:00–6:00AM" },
    { time: "11:30AM", label: "10P Jiu Jitsu", duration: "11:30AM–1:00PM" },
    { time: "5:00PM", label: "Adult Wrestling", duration: "5:00–6:00PM" },
    { time: "6:00PM", label: "10P Jiu Jitsu", duration: "6:00–7:00PM" },
    { time: "6:00PM", label: "Muay Thai", duration: "6:00–7:00PM" },
    { time: "7:00PM", label: "Advanced Jiu Jitsu", duration: "7:00–8:00PM" },
    { time: "7:00PM", label: "Boxing", duration: "7:00–8:00PM" },
  ],
  Wed: [
    { time: "5:00AM", label: "10P Jiu Jitsu", duration: "5:00–6:00AM" },
    { time: "8:30AM", label: "10P Jiu Jitsu", duration: "8:30–10:00AM" },
    { time: "12:00PM", label: "Muay Thai", duration: "12:00–1:00PM" },
    { time: "12:00PM", label: "Open Mat", duration: "12:00–1:00PM" },
    { time: "6:00PM", label: "10P Jiu Jitsu", duration: "6:00–7:00PM" },
    { time: "6:00PM", label: "Muay Thai", duration: "6:00–7:00PM" },
    { time: "7:00PM", label: "Advanced Jiu Jitsu", duration: "7:00–8:00PM" },
    { time: "8:00PM", label: "MMA", duration: "8:00–9:00PM" },
  ],
  Thu: [
    { time: "5:00AM", label: "10P Jiu Jitsu", duration: "5:00–6:00AM" },
    { time: "11:30AM", label: "10P Jiu Jitsu", duration: "11:30AM–1:00PM" },
    { time: "5:00PM", label: "Adult Wrestling", duration: "5:00–6:00PM" },
    { time: "6:00PM", label: "10P Jiu Jitsu", duration: "6:00–7:00PM" },
    { time: "6:00PM", label: "Muay Thai", duration: "6:00–7:00PM" },
    { time: "7:00PM", label: "Advanced Jiu Jitsu", duration: "7:00–8:00PM" },
    { time: "7:00PM", label: "Boxing", duration: "7:00–8:00PM" },
  ],
  Fri: [
    { time: "8:30AM", label: "Task Based Games", duration: "8:30–10:00AM" },
    { time: "12:00PM", label: "10P Jiu Jitsu", duration: "12:00–1:00PM" },
    { time: "5:00PM", label: "Muay Thai", duration: "5:00–6:00PM" },
    { time: "5:00PM", label: "Basics Jiu Jitsu", duration: "5:00–6:00PM" },
    { time: "6:00PM", label: "Open Mat", duration: "6:00–8:00PM" },
    { time: "8:00PM", label: "MMA", duration: "8:00–9:00PM" },
  ],
  Sat: [{ time: "10:00AM", label: "Leg Locks", duration: "10:00–11:30AM" }],
};

const days = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat"] as const;

// Color coding by keyword in class label
function getClassColor(label: string): string {
  const l = label.toLowerCase();
  if (
    l.includes("jiu jitsu") ||
    l.includes("comp") ||
    l.includes("basics jiu") ||
    l.includes("leg locks")
  )
    return "bg-primary/15 text-primary border-primary/30";
  if (
    l.includes("muay thai") ||
    l.includes("boxing") ||
    l.includes("task based")
  )
    return "bg-secondary text-secondary-foreground border-border";
  if (l.includes("wrestling")) return "bg-muted text-foreground border-border";
  if (l.includes("mma")) return "bg-card text-foreground border-border";
  if (l.includes("open mat"))
    return "bg-accent/20 text-accent-foreground border-accent/40";
  return "bg-card text-foreground border-border";
}

export default function ScheduleTable() {
  return (
    <div className="w-full overflow-x-auto rounded-xl border border-border shadow-card">
      <table
        className="w-full min-w-[640px] border-collapse text-sm"
        aria-label="Weekly class schedule"
      >
        <thead>
          <tr className="bg-primary text-primary-foreground">
            {days.map((day) => (
              <th
                key={day}
                scope="col"
                className="px-3 py-3 text-center font-display font-bold text-xs tracking-widest uppercase border border-primary/30"
              >
                {day}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          <tr className="align-top bg-card">
            {days.map((day) => (
              <td
                key={day}
                className="px-2 py-3 border border-border/40 align-top"
              >
                <div className="flex flex-col gap-1.5">
                  {schedule[day].map((cls) => (
                    <div
                      key={`${day}-${cls.label}-${cls.duration}`}
                      className={cn(
                        "rounded-md px-2 py-2 text-[11px] font-body font-semibold leading-snug border",
                        getClassColor(cls.label),
                      )}
                    >
                      <div className="font-bold">{cls.label}</div>
                      <div className="opacity-70 font-normal text-[10px] mt-0.5">
                        {cls.duration}
                      </div>
                    </div>
                  ))}
                </div>
              </td>
            ))}
          </tr>
        </tbody>
      </table>

      {/* Note */}
      <div className="px-4 py-3 bg-muted/40 border-t border-border flex flex-wrap gap-3 items-center">
        <span className="text-xs font-body text-muted-foreground italic">
          * All classes are beginner-friendly unless marked advanced
        </span>
      </div>
    </div>
  );
}
